import React from "react";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Vysledok", "caption": "Výsledok", 'filter': 'string'},
    {"label": "Farba", 'filter': 'string'}
]

function BTKResults(props) {
    const initialFilters = [
        {
            'label': 'Vysledok',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Farba',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Stav',
        }
    ]
    const baseUrl = '/btk/btks_results'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Vysledok': `/btk_results/btk_result/${entry.id}`
        }))
    }

    function colorize() {
        const rows = document.getElementsByTagName("tr")
        const new_rows = Array.from(rows)
        new_rows.splice(0,1)
        new_rows.forEach(row => {
            const cell = row.getElementsByTagName("td")[1]
            const color = cell.innerText
            cell.style.backgroundColor = color
        })
    }

    React.useEffect(() => {
        colorize()
    }, [data])

    return (
        <ListViewCommon baseUrlFrontend={`/btk_results/btk_result`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Výsledky Kontroly BTK"}
        />
    )
}

export default BTKResults
